// import { useGetCurrentHelpPageUrl } from '@legacy/stores/PageStore/pageStore.zustand';
import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';

import { HELP_URL } from './HelpButton.constants';
import { IconButton } from '@/components/ui/IconButton';
import { areaIcons } from '@/constants/areaIcons';

/* 
 NOT FULLY REFACTORED
 This is mostly a copy of the legacy HelpButton component, 
 but it has been modified to use the new IconButton component to follow the new design
*/
export const HelpButton = () => {
  const { t } = useTranslation('header');
  // #28475356320 DRO: keep here for reference in the future since it might be used in the new system
  // const helpUrl =  useGetCurrentHelpPageUrl();
  const helpUrl = HELP_URL; // useGetCurrentHelpPageUrl();
  return (
    <IconButton
      size="small"
      iconName={areaIcons.help}
      tooltip={t('HelpSectionLink')}
      color="secondary"
      component="a"
      href={helpUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-automation-id="TopBarHelpButton"
      iconProps={{ color: scssVariables.ColorBlack100 }}
    />
  );
};
